export default __webpack_public_path__ + "static/welcome-piano-dbb29c7b0022c58f6a785326279df042.mp3";